import React, { useState } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Nav from './components/Nav';
import Footer from './components/Footer';
import { StudentHome, StudentProgrammes } from './pages/StudentPages';
import InboxPage from './pages/InboxPage';
import { AdminHome, AdminProgrammes, AdminStudents, AdminAuditLog } from './pages/AdminPages';
import AdminEmailPage from './pages/AdminEmailPage';
import AdminStats from './pages/AdminStatsPage';

function AppContent() {
  const { user, loading, recoveryMode } = useApp();
  const [activeTab, setActiveTab] = useState('Home');

  if (recoveryMode) return <ResetPasswordPage />;

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bone)' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 36, height: 36, border: '3px solid var(--dark-10)', borderTopColor: 'var(--orange)', borderRadius: '50%', margin: '0 auto 14px', animation: 'spin 0.75s linear infinite' }} />
        <p style={{ fontSize: 14, color: 'var(--dark-60)', fontFamily: 'var(--font-heading)', fontWeight: 600, margin: 0 }}>Loading…</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );

  if (!user) return <LoginPage />;

  const renderPage = () => {
    if (user.role === 'admin') {
      switch (activeTab) {
        case 'Home': return <AdminHome setActiveTab={setActiveTab} />;
        case 'Programmes': return <AdminProgrammes />;
        case 'Students': return <AdminStudents />;
        case 'Email': return <AdminEmailPage />;
        case 'Stats': return <AdminStats />;
        case 'Audit Log': return <AdminAuditLog />;
        default: return <AdminHome setActiveTab={setActiveTab} />;
      }
    } else {
      switch (activeTab) {
        case 'Home': return <StudentHome setActiveTab={setActiveTab} />;
        case 'My Programmes': return <StudentProgrammes />;
        case 'Inbox': return <InboxPage />;
        default: return <StudentHome setActiveTab={setActiveTab} />;
      }
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bone)' }}>
      <Nav activeTab={activeTab} setActiveTab={setActiveTab} />
      <main style={{ flex: 1 }} key={activeTab}>{renderPage()}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}
